import PropTypes from 'prop-types'
import React from 'react'
import Footer from 'components/Footer'
import MainLayout from 'layouts/MainLayout'
import { useFaqNavItems } from 'modules/Faq/hooks/useFaqNavItems'
import FaqLayoutHeader from 'modules/Faq/layouts/FaqLayoutHeader'
import faqStyles from 'modules/Faq/styles/Faq.module.scss'

const FaqMainLayout = ({ children = null }) => {
  const { items, loading } = useFaqNavItems(true)

  return (
    <MainLayout
      className={faqStyles['faq-main-layout']}
      collapsible={false}
      footer={<Footer compact />}
      hasBalance={false}
      header={<FaqLayoutHeader showSidebarToggle />}
      navItems={items}
      navLoading={loading}
    >
      {children}
    </MainLayout>
  )
}

FaqMainLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]),
}

export default FaqMainLayout
